import * as React from "react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"
import { Selector, ItemBlockPart } from "@tenforce/toolbox-selector-react"
import {
    TableBody,
    RowContent,
    Cell,
    CellType,
} from "@tenforce/toolbox-table-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { IView } from "../index"
import { ITenForceWindow } from "../../../global"

declare let window: ITenForceWindow

const ViewSymbols = new Map<string, string>(
    Object.entries({
        Cards: Symbols.Cards,
        C5: Symbols.CalendarView,
        C7: Symbols.CalendarView,
        G: Symbols.GraphView,
        GR: Symbols.HierarchicalView,
        H: Symbols.HierarchicalView,
        HC: Symbols.HierarchicalView,
        L: Symbols.ListView,
        LC: Symbols.ListView,
        CollectionV1: Symbols.ListView,
        M: Symbols.MapView,
        Pt: Symbols.PivotTableView,
        S: Symbols.StatusView,
        T: Symbols.TaskBoardView,
    }),
)

interface Props {
    selectionId: string
    selectedView: IView
    views: IView[]
    updateSelectedListView: (selectedValue: IView) => void
}

interface State {
    show: boolean
}

export default class ChangeView extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            show: false,
        }
    }

    render(): JSX.Element {
        const { show } = this.state
        const { selectedView, views } = this.props

        return (
            <>
                <Selector
                    isSingleSelect={true}
                    isExpanded={false}
                    isWrapped={false}
                >
                    <ItemBlockPart
                        id="changeViewButton"
                        onUnselected={this.showModal}
                        isSelected={true}
                    >
                        {this.getSymbol(selectedView.Code)}
                        {selectedView.Label}
                    </ItemBlockPart>
                </Selector>

                <Modal
                    isShown={show}
                    containerProps={{
                        id: "changeViewModal",
                        targetSelector: "#changeViewButton",
                        onClose: this.hideModal,
                    }}
                >
                    <TableBody>
                        {views.map((view, i) => (
                            <RowContent
                                key={i}
                                data-ft-label={view.Label}
                                data-ft-action={view.Code}
                                extraClasses="changeViewRow"
                            >
                                <Cell type={CellType.action}>
                                    <Action
                                        actionType={ActionType.block}
                                        extraClasses="text-black tw-px-2"
                                        onClick={(): void =>
                                            this.changeView(view)
                                        }
                                        data-ft-action="changeView"
                                    >
                                        {this.getSymbol(view.Code)}
                                        {view.Label}
                                    </Action>
                                </Cell>
                                {view.Code === selectedView.Code && (
                                    <Cell
                                        extraClasses="is-disabled toolbox-table__cell--0 "
                                        data-ft-current
                                    >
                                        <Action
                                            actionType={ActionType.icon}
                                            extraClasses="text-black"
                                            isDisabled={true}
                                        >
                                            {Symbols.Confirm}
                                        </Action>
                                    </Cell>
                                )}
                            </RowContent>
                        ))}
                    </TableBody>
                </Modal>
            </>
        )
    }

    showModal = (): void => this.setState({ show: true })

    hideModal = (): void => this.setState({ show: false })

    changeView = (view: IView): void => {
        window.env.datalist.getInstance().switchView(view.Code)
        this.props.updateSelectedListView(view)
        this.hideModal()
    }

    getSymbol = (code: string): string =>
        ViewSymbols.has(code) ? `${ViewSymbols.get(code)} ` : ""
}
